export default "__VITE_ASSET__f7aaf18b__"